import type { JSX, ParentComponent } from "solid-js";

/**
 * DeepLinkingProvider handles incoming URLs. Stubbed as Capacitor has been removed.
 */
export const DeepLinkingProvider: ParentComponent = (props): JSX.Element => (
  <>
    {props.children}
    {null}
  </>
);
